export const PasswordCheck = (password: string) => {
  //checks to make sure the password has at least 8 characters, 1 number, 1 uppercase
  const passwordRegex =  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
  return passwordRegex.test(password);
}